import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'podcastSanitizeHtml'
})
export class PodcastSanitizeHtmlPipe implements PipeTransform {

  constructor(private _sanitizer:DomSanitizer) {
  }

  transform(v:string):SafeHtml {
    var div = document.createElement('div');
    div.innerHTML = v;
    var scripts:any = div.getElementsByTagName('script');
    var i = scripts.length;
    while (i--) {
      scripts[i].parentNode.removeChild(scripts[i]);
    }
    return this._sanitizer.bypassSecurityTrustHtml(div.innerHTML);
    // return this._sanitizer.bypassSecurityTrustHtml(v);
  }

}
